import React from 'react';
import { parseISO } from 'date-fns';
import { MonthsMap, hasOwn, safeStartOfMonth } from '@features/price-graph';

export const useCurrentMonth = (openedDate: Date, monthsPricesMap: MonthsMap) => {
	const isMonthExist = React.useCallback(
		(date: Date): boolean => {
			const startOfMonth = safeStartOfMonth(date).toISOString();

			return hasOwn(monthsPricesMap, startOfMonth);
		},
		[monthsPricesMap]
	);

	const currentMonthISO = React.useMemo<string>(() => {
		const date = openedDate && safeStartOfMonth(openedDate).toISOString();

		if (!isMonthExist(parseISO(date))) {
			for (const dateISO in monthsPricesMap) {
				if (hasOwn(monthsPricesMap, dateISO)) {
					return dateISO;
				}
			}
		}

		return date;
	}, [openedDate, monthsPricesMap, isMonthExist]);

	return { currentMonthISO, isMonthExist };
};
